import { render, staticRenderFns } from "./AddNewPostDialog.vue?vue&type=template&id=76274748&scoped=true"
import script from "./AddNewPostDialog.vue?vue&type=script&lang=js"
export * from "./AddNewPostDialog.vue?vue&type=script&lang=js"
import style0 from "./AddNewPostDialog.vue?vue&type=style&index=0&id=76274748&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76274748",
  null
  
)

export default component.exports